import clsx from 'clsx';
import { Icon } from 'ui';
import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import useInputPointsNumericScale from './useInputPointsNumericScale';

const InputPointsNumericScale = ({
  onChange,
  placeholder,
  type,
  disabled,
  referer,
  size,
  isScoreReadOnly,
  max,
  min,
  showDotted,
  isLate,
  colorsPoints,
  changeError,
  numberDecimals,
  ...props
}) => {
  const { value, hasError, onChangeText, onFocus, onBlur, statusColor, t } = useInputPointsNumericScale({
    props,
    max,
    min,
    onChange,
    colorsPoints,
    changeError,
    numberDecimals,
  });

  return (
    <div className={clsx('input-points', `input-points--status-${statusColor}`, { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <input
          className={clsx('input-points__input', { 'input-points__input--disabled': disabled })}
          type={type}
          placeholder={placeholder}
          onChange={onChangeText}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          ref={referer}
          readOnly={isScoreReadOnly}
          max={max}
          min={min}
          value={value}
        />
        {isLate && (
          <div className="input-points__late">
            <TooltipCustom title={t('lesson:Delivered late')} placement="top" hasArrow>
              <div>
                <Icon name="exclamation-circle" />
              </div>
            </TooltipCustom>
          </div>
        )}
        <label className="input-points__points-total">/{max}</label>
      </div>
    </div>
  );
};

InputPointsNumericScale.propTypes = {
  changeError: PropTypes.func,
  colorsPoints: PropTypes.bool,
  disabled: PropTypes.bool,
  isLate: PropTypes.bool,
  isScoreReadOnly: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  numberDecimals: PropTypes.oneOf([0, 1, 2, 3]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  referer: PropTypes.object,
  showDotted: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InputPointsNumericScale.defaultProps = {
  placeholder: '0',
  type: 'text',
  disabled: false,
  max: 10,
  size: 'default',
  showDotted: false,
  isLate: false,
  numberDecimals: 2,
};

export default InputPointsNumericScale;
